export const getHorizontalRuleNode = () => ({
  group: 'block',
  parseDOM: [{
    tag: 'hr'
  }],
  toDOM: function toDOM() {
    return ['hr'];
  }
});